var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3538 24.0002L22.118 27.7643L29.6462 20.2361M16.1607 10.2556C17.5112 10.1478 18.7932 9.6168 19.8243 8.7381C22.2305 6.68756 25.7695 6.68756 28.1757 8.7381C29.2068 9.6168 30.4888 10.1478 31.8393 10.2556C34.9907 10.5071 37.4931 13.0095 37.7446 16.1609C37.8524 17.5114 38.3834 18.7934 39.2621 19.8245C41.3126 22.2307 41.3126 25.7697 39.2621 28.1759C38.3834 29.207 37.8524 30.489 37.7446 31.8395C37.4931 34.9908 34.9907 37.4933 31.8393 37.7448C30.4888 37.8526 29.2068 38.3836 28.1757 39.2623C25.7695 41.3128 22.2305 41.3128 19.8243 39.2623C18.7932 38.3836 17.5112 37.8526 16.1607 37.7448C13.0094 37.4933 10.5069 34.9908 10.2554 31.8395C10.1477 30.489 9.61662 29.207 8.73792 28.1759C6.68738 25.7697 6.68738 22.2307 8.73792 19.8245C9.61662 18.7934 10.1477 17.5114 10.2554 16.1609C10.5069 13.0095 13.0094 10.5071 16.1607 10.2556Z",
    fill: "none",
    stroke: "current",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating);
export default __webpack_public_path__ + "static/media/rating.aa99637e6ef7c6c0498e6d17e9122077.svg";
export { ForwardRef as ReactComponent };